module.exports = __webpack_public_path__ + "static/testimonial-5-2443d79e8ff0ec8bd37b8ca3522ffac7.png";